import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  confirm() {
    const form = this.element.querySelector("form[data-delete-form]")
    if (form) {
      form.requestSubmit()
    }
    this.dialogTarget.close()
  }

  cancel() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
